import React from "react";

import { FormEnabler, ValidatedForm, MInput, MSelect, MToggle } from "components/forms";
import { COMPETITION_CLASS_TITLE } from "const";
import { Button, Card, CardBody, CardFooter, Icon } from "design-react-kit";
import { adminService, networkErrorHelper } from "libs";

export class AdminRevisorForm extends ValidatedForm {
  state = {
    context: "",
    isEnabled: false,
    revisions: [{ competitionClass: "", revisionMax: "" }],
    formActive: false,
    initialState: null,
  };

  ERROR_MESSAGES = {};
  validation = {};

  PAYLOAD_CONTEXT = {
    options: [
      { label: "Selezionare", value: "" },
      { label: "30cfu", value: "abilitazione30" },
      { label: "60cfu", value: "abilitazione60" },
      { label: "English", value: "english" },
      { label: "Tirocinio diretto", value: "lessonActivity" },
      { label: "TFA Indire", value: "tfa_indire" },
      { label: "30cfu (ex Art 13)", value: "30cfu_art13" },
    ],
  };

  PAYLOAD_COMPETITIONCLASS = {
    options: [
      { value: "", label: "Seleziona classe di concorso" },
      ...Object.entries(COMPETITION_CLASS_TITLE).map(([value, label]) => ({
        value,
        label: `${value} - ${label}`,
      })),
    ],
  };

  componentDidMount() {
    const { revisor } = this.props;
    if (revisor) {
      const revisions = revisor.revisionMax
        ? Object.entries(revisor.revisionMax).map(([competitionClass, revisionMax]) => ({
            id: Math.random().toString(),
            competitionClass,
            revisionMax,
          }))
        : [{ competitionClass: "", revisionMax: "" }];

      const newState = {
        context: revisor.context,
        isEnabled: revisor.isEnabled,
        revisions,
        initialState: {
          context: revisor.context,
          isEnabled: revisor.isEnabled,
          revisions,
        },
      };

      this.setState(newState);
    }
  }

  onChangeContext = (id, value) => {
    this.setState({ context: value });
  };

  onChangeIsEnabled = (id, value) => {
    this.setState({ isEnabled: value });
  };

  addRow = () => {
    this.setState((prev) => ({
      revisions: [{ id: Math.random().toString(), competitionClass: "", revisionMax: "" }, ...prev.revisions],
    }));
  };

  removeRow = (index) => {
    this.setState((prev) => {
      const updated = [...prev.revisions];
      updated.splice(index, 1);
      return { revisions: updated };
    });
  };

  updateRow = (index, field, value) => {
    const updated = [...this.state.revisions];
    updated[index][field] = value;
    this.setState({ revisions: updated }, () => {});
  };

  saveRemote = () => {
    const { revisions } = this.state;
    const { revisor } = this.props;

    const revisionMaxObj = {};
    const classList = [];

    revisions.forEach(({ competitionClass, revisionMax }) => {
      if (competitionClass && revisionMax !== "") {
        revisionMaxObj[competitionClass] = parseInt(revisionMax);
      }
      classList.push(competitionClass);
    });

    const payload = {
      ...revisor,
      isEnabled: this.state.isEnabled,
      userId: String(revisor.userId),
      competitionClass: classList.join(","),
      revisionMax: revisionMaxObj,
    };

    if (revisor.id) {
      adminService
        .updateRevisor(payload)
        .then((result) => {
          const updatedRevisor = result.data.payload.revisor;

          this.setState({
            context: updatedRevisor.context,
            isEnabled: updatedRevisor.isEnabled,
            revisions,
            formActive: false,
          });
        })
        .catch((errors) => {
          console.log(errors);
          networkErrorHelper.notify(errors);
        });
    } else {
      adminService
        .insertRevisor(payload)
        .then((result) => {
          const insertedRevisor = result.data.payload.revisor;

          this.setState({
            context: insertedRevisor.context,
            isEnabled: insertedRevisor.isEnabled,
            revisions,
            formActive: false,
          });
          this.setState({ formActive: false });
        })
        .catch((errors) => {
          console.log(errors);
          networkErrorHelper.notify(errors);
        });
    }
  };

  toggleForm = () => {
    this.setState((prev) => {
      if (prev.formActive && prev.initialState) {
        return {
          ...prev.initialState,
          formActive: false,
        };
      } else {
        return { formActive: true };
      }
    });
  };

  renderInfo() {
    const { context, isEnabled, revisions } = this.state;

    return (
      <Card className="card-bg card-big rounded shadow border-bottom-card">
        <div className="flag-icon" />
        <div className="etichetta">
          <Icon icon="it-user" padding={false} />
          <span>Revisore</span>
        </div>
        <CardBody>
          <p>
            <strong>Context:</strong> {context}
          </p>
          <p>
            <strong>Abilitato:</strong> {isEnabled ? "Sì" : "No"}
          </p>
          <strong>Revisioni:</strong>
          <ul>
            {revisions.map((revision, index) => {
              const description = COMPETITION_CLASS_TITLE[revision.competitionClass];
              return (
                <li key={index}>
                  {revision.competitionClass} — {description} (max {revision.revisionMax} revisioni )
                </li>
              );
            })}
          </ul>
        </CardBody>
        <CardFooter>
          <Button color="primary bg-dark float-right" onClick={this.toggleForm}>
            Modifica
          </Button>
        </CardFooter>
      </Card>
    );
  }

  renderForm() {
    const { context, isEnabled, revisions } = this.state;

    return (
      <>
        <Card tag="div" className="card-bg card-big rounded shadow border-bottom-card">
          <div className="flag-icon" />
          <div className="etichetta">
            <Icon icon="it-user" padding={false} />
            <span>Gestione revisore</span>
          </div>

          <CardBody tag="div">
            <form>
              <div className="row">
                <div className="col-md-4 mr-3">
                  <MSelect id="context" label="Context" value={context} onChange={this.onChangeContext} payload={this.PAYLOAD_CONTEXT} />
                </div>

                <div className="col-md-3">
                  <MToggle id="isEnabled" label="Abilitato" value={isEnabled} onChange={this.onChangeIsEnabled} />
                </div>
              </div>
              <hr className="my-3" />
              <div className="d-flex justify-content-end mb-3">
                <Button color="primary bg-dark" className="mt-3" onClick={this.addRow}>
                  Aggiungi classe di concorso
                </Button>
              </div>
              {revisions.map((row, index) => (
                <div className="row my-5" key={row.id}>
                  <div className="col-md-6">
                    <MSelect
                      id={`competitionClass-${row.id}`}
                      label="Classe di concorso"
                      value={row.competitionClass}
                      payload={this.PAYLOAD_COMPETITIONCLASS}
                      onChange={(id, value) => this.updateRow(index, "competitionClass", value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <MInput
                      id={`revisionMax-${row.id}`}
                      label="Num. massimo revisioni"
                      type="number"
                      value={row.revisionMax}
                      onChange={(id, value) => this.updateRow(index, "revisionMax", value)}
                    />
                  </div>

                  <div className="col-md-2">
                    <Button color="primary bg-dark" onClick={() => this.removeRow(index)}>
                      Rimuovi
                    </Button>
                  </div>
                </div>
              ))}
              <hr className="my-4" />
              <FormEnabler isFormActive={true} onCancel={this.toggleForm} onSubmit={this.saveRemote} disableSave={false} />
            </form>
          </CardBody>
        </Card>
      </>
    );
  }

  render() {
    return this.state.formActive ? this.renderForm() : this.renderInfo();
  }
}
